import './Pagination.css';
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// 生成页码序列（含省略号），桌面用；移动端只显示 上一页 / x/y / 下一页
const buildPages = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const left = Math.max(2, current - 1);
  const right = Math.min(total - 1, current + 1);
  if (left > 2) pages.push('…');
  for (let p = left; p <= right; p++) pages.push(p);
  if (right < total - 1) pages.push('…');
  pages.push(total);
  return pages;
};

const Pagination = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);
  const go = (p) => { if (p >= 1 && p <= totalPages && p !== page) onChange(p); };

  return (
    <nav className="pagination" aria-label="分页">
      <button className="pg-btn pg-nav" onClick={() => go(page - 1)} disabled={page === 1} aria-label="上一页">
        <ChevronLeft size={16} />
      </button>

      {/* 桌面：完整页码 */}
      <span className="pg-pages">
        {pages.map((p, i) =>
          p === '…' ? (
            <span key={`e${i}`} className="pg-ellipsis">…</span>
          ) : (
            <button
              key={p}
              className={`pg-btn ${p === page ? 'active' : ''}`}
              onClick={() => go(p)}
            >
              {p}
            </button>
          )
        )}
      </span>

      {/* 移动：x / y */}
      <span className="pg-compact">{page} / {totalPages}</span>

      <button className="pg-btn pg-nav" onClick={() => go(page + 1)} disabled={page === totalPages} aria-label="下一页">
        <ChevronRight size={16} />
      </button>
    </nav>
  );
};

export default Pagination;
